export const coachCanAccessPath = (pathname: string) =>
  pathname === '/coach' ||
  pathname.startsWith('/coach/') ||
  ['/settings', '/settings/profile', '/settings/security'].includes(pathname);
